const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

const minutes = (value) => {
  const [hours, mins] = (value || "").split(":").map(Number);
  return Number.isFinite(hours) && Number.isFinite(mins) ? hours * 60 + mins : null;
};

export const restaurantOpenStatus = (hours, now = new Date()) => {
  if (!Array.isArray(hours) || !hours.length) return null;
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata", weekday: "long", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(now);
  const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const dayIndex = DAYS.indexOf(value.weekday.toLowerCase());
  const schedule = hours.find((entry) => entry.day_of_week === dayIndex);
  if (!schedule?.is_open) return { open: false, label: "Closed today" };
  const current = Number(value.hour) * 60 + Number(value.minute);
  const opens = minutes(schedule.opens_at);
  const closes = minutes(schedule.closes_at);
  if (opens === null || closes === null) return { open: true, label: "Open today" };
  const open = closes < opens ? current >= opens || current < closes : current >= opens && current < closes;
  return { open, label: open ? `Open now · until ${schedule.closes_at}` : `Closed now · opens ${schedule.opens_at}` };
};

